import { Box, Heading, Stack, VStack } from '@chakra-ui/react';
import { createListCollection } from '@chakra-ui/react';
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText
} from '../../components/ui/select';

import { Navigate } from 'react-router-dom';
import VideoFileUpload from './VideoFileUpload';
import { useState } from 'react';
import { useAddPost } from 'hooks/posts';
import { useAuth } from 'hooks/auth';

export default function NewPostStart() {
  const [videoId, setVideoId] = useState('');
  const [sourceCameraFormat, setSourceCameraFormat] = useState('');
  const { addPost, isLoading: addPostLoading } = useAddPost();
  const { user: authUser, authToken, isLoading: authLoading } = useAuth();

  const sourceCameraFormats = createListCollection({
    items: [
      { label: 'Apple Spatial Video', value: 'APPLE_SPATIAL_3D' },
      { label: 'Side-by-Side 3D Video', value: 'SBS_3D' },
      { label: 'Over-Under 3D Video', value: 'OU_3D' },
      { label: 'GoPro 360-degree Video', value: 'GOPRO_360' },
      { label: 'Insta 360-degree Video', value: 'INSTA_360' }
    ]
  });

  function handleVideoUploaded(videoId, sourceFileName, sourceFileExtension) {
    async function createPost() {
      await addPost({
        uid: authUser.id,
        id: videoId,
        videoId,
        sourceFileName,
        sourceFileExtension,
        sourceCameraFormat
      });

      // Set uploaded video ID into state so we can redirect to the page where
      // we'll finish creating the post
      setVideoId(videoId);
    }

    createPost();
  }

  if (authLoading || addPostLoading) return '';

  return (
    <Box maxW="600px" mx="auto" py="5">
      <VStack>
        <Stack>
          <Heading size="md">Video Source Format</Heading>
          <SelectRoot
            collection={sourceCameraFormats}
            size="sm"
            width="320px"
            onValueChange={(e) => {
              if (e.value) {
                setSourceCameraFormat(e.value[0]);
              }
            }}
          >
            <SelectTrigger>
              <SelectValueText placeholder="Select Video Source" />
            </SelectTrigger>
            <SelectContent>
              {sourceCameraFormats.items.map((source) => (
                <SelectItem item={source} key={source.value}>
                  {source.label}
                </SelectItem>
              ))}
            </SelectContent>
          </SelectRoot>
        </Stack>
        <Stack py="5">
          <Heading size="md">Upload a spatial video</Heading>
          <VideoFileUpload
            onVideoUploaded={handleVideoUploaded}
            authUser={authUser}
            authToken={authToken}
            width="320px"
            disabled={!sourceCameraFormat}
          />
          {videoId !== '' && sourceCameraFormat !== '' ? (
            <Navigate to={`/app/post/${videoId}`} replace={true} />
          ) : (
            ''
          )}
        </Stack>
      </VStack>
    </Box>
  );
}
